module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "margin-left": "auto",
      "margin-right": "auto",
      "width": "50%",
      "margin-top": "6px"
    },
    attrs: {
      "id": _vm.identifier
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bf67172","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/widgets/types/PieChart.vue
// module id = 1811
// module chunks = 0